module.exports = __webpack_public_path__ + "img/gambar1.4001eb98.png";